import { render, staticRenderFns } from "./fflink.vue?vue&type=template&id=6bba7988&"
import script from "./fflink.vue?vue&type=script&lang=js&"
export * from "./fflink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports